// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/mnt/h/42WebCode/everglows.com/gatsby-starter-eventually-master/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/mnt/h/42WebCode/everglows.com/gatsby-starter-eventually-master/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import("/mnt/h/42WebCode/everglows.com/gatsby-starter-eventually-master/.cache/data.json")

